import React, {
  useState,
  useContext,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import { useForm } from "react-hook-form";
import { AppContexts } from "../../providers";
import { useHistory } from "react-router";
import { Icon, Image } from "uikit-react";
import UIkit from "uikit";
import moment from "moment";
import ScenarioDelete from "./delete.js";
import QRPart from "../common/Qrcode";

const TableRow = ({ guide, index, allTags }) => {
  const {
    updateRental,
    setRental,
    selectedFlags,
    setSelectedFlags,
    setIsNew,
    createRental,
  } = useContext(AppContexts.RentalsContext);
  const history = useHistory();

  return (
    <>
      <tr>
        <td>Yes</td>
        <td>Category Name</td>
        <td>WiFi Not Working</td>    
        <td>
          - Action Step 1<br/>
          - Action Step 2<br/>
          - Action Step 3
        </td>    
        <td>Yes</td>    
        <td>
          - Escalation Step 1<br/>
          - Escalation Step 2
        </td>    
        <td className="td-w-240 hms-action-btn">
          <div className="uk-inline">
            <button
              className="uk-button"
              type="button"
              uk-toggle={`target: #addPropertyGuide-modal`}
              onClick={() => {
                setIsNew(false);
                setRental(guide);
              }}
              uk-tooltip="Edit"
            >
              <img src="/images/edit.svg" />
            </button>
          </div>

          <div className="uk-inline">
            <button
              className="uk-button"
              type="button"
              uk-toggle="target: #modal-property-delete"
              onClick={() => setRental(guide)}
              uk-tooltip="Delete"
            >
              <img src="/images/delete.svg" />
            </button>
          </div>
        </td>
      </tr>
      <ScenarioDelete />
    </>
  );
};

export default TableRow;
